// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KeyQuality } from "../schema";

export function serialize_KeyQuality_internal(value: KeyQuality): unknown {
  return ((value: { key: string; keyQualityId: number; type: "INTRINSIC" | "EXTRINSIC" }): unknown => {
    return {
      key: ((value: string): unknown => {
        return value;
      })(value["key"]),
      keyQualityId: ((value: number): unknown => {
        return value;
      })(value["keyQualityId"]),
      type: ((value: "INTRINSIC" | "EXTRINSIC"): unknown => {
        return value;
      })(value["type"]),
    };
  })(value);
}
export function serialize_KeyQuality(obj: KeyQuality): string {
  return renderJsonWithNumbersAsBigint(serialize_KeyQuality_internal(obj));
}
export function deserialize_KeyQuality_internal(value: unknown): ParserResult<KeyQuality> {
  return ((
    value: unknown,
  ): ParserResult<{
    key: string;
    keyQualityId: number;
    type: "INTRINSIC" | "EXTRINSIC";
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/KeyQuality]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/KeyQuality]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "key")) {
      return { success: false, reason: `[#/components/schemas/KeyQuality/key]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'key'.` };
    }
    const parsed_key = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/KeyQuality/key]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["key"]);
    })();
    if (!parsed_key.success) {
      return { success: false, reason: parsed_key.reason };
    }
    if (!hasProp(value, "keyQualityId")) {
      return { success: false, reason: `[#/components/schemas/KeyQuality/keyQualityId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'keyQualityId'.` };
    }
    const parsed_keyQualityId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/KeyQuality/keyQualityId]: '${value}' expected to be of type number.` };
      })(value["keyQualityId"]);
    })();
    if (!parsed_keyQualityId.success) {
      return { success: false, reason: parsed_keyQualityId.reason };
    }
    if (!hasProp(value, "type")) {
      return { success: false, reason: `[#/components/schemas/KeyQuality/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
    }
    const parsed_type = ((): ParserResult<"INTRINSIC" | "EXTRINSIC"> => {
      return ((value: unknown): ParserResult<"INTRINSIC" | "EXTRINSIC"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/KeyQuality/type]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "INTRINSIC":
            return { success: true, value: "INTRINSIC" };
          case "EXTRINSIC":
            return { success: true, value: "EXTRINSIC" };
          default:
            return { success: false, reason: `[#/components/schemas/KeyQuality/type]: '${value}' expected to be enum, one of 'INTRINSIC, EXTRINSIC'.` };
        }
      })(value["type"]);
    })();
    if (!parsed_type.success) {
      return { success: false, reason: parsed_type.reason };
    }
    return { success: true, value: { key: parsed_key.value, keyQualityId: parsed_keyQualityId.value, type: parsed_type.value } };
  })(value);
}
export function deserialize_KeyQuality(str: string): ParserResult<KeyQuality> {
  return deserialize_KeyQuality_internal(parseJsonWithNumbersAsBigint(str));
}
